<div *ngIf="logos" fxLayout="column" fxLayoutGap="20px">
  <div *ngFor="let logoType of logoTypes">
    <div>
      {{ logoType.name }}
        <app-logo-upload [logo]="getLogoByType(logoType.name)" [id]="id" [type]="logoType" (logoUploaded)="logoUploaded($event)"></app-logo-upload>
    </div>
  </div>
</div>